import angular from "angular";
import FakturaciaService from "./FakturaciaService";
import FakturaEditCtrl from "./FakturaEditCtrl";
import FakturaBatchCtrl from "./FakturaBatchCtrl";
import FakturaciaCtrl from "./FakturaciaCtrl";
import "./styles.css";

export default angular
.module("sonas.fakturacia", [])
.config(function routes($stateProvider){
  $stateProvider
  .state("fakturacia", {
    url: "/fakturacia",
    template: require("./faktura.edit.html"),
    controller: FakturaEditCtrl,
    controllerAs: "ctrl",
    resolve: {
      faktura: () => null
    }
  })
  .state("fakturacia-pof", {
    url: "/fakturacia-pof?pofs",
    template: require("./faktura.edit.html"),
    controller: FakturaEditCtrl,
    controllerAs: "ctrl",
    resolve: {
      faktura: (OTEService, $stateParams) => OTEService.getInvoiceData(angular.isArray($stateParams.pofs)?$stateParams.pofs:[$stateParams.pofs])
    }
  })
  .state("fakturacia-batch", {
    url: "/fakturacia-batch",
    template: require("./faktura.batch.html"),
    controller: FakturaBatchCtrl,
    controllerAs: "ctrl",
    resolve: {}
  })
  .state('export-duf', {
    url: '/export-duf',
    template: require('./export-duf.html'),
    controller: FakturaciaCtrl,
    controllerAs: 'ctrl',
  })
  .state('export-pof', {
    url: '/export-pof',
    template: require('./export-pof.html'),
    controller: FakturaciaCtrl,
    controllerAs: 'ctrl',
  })
})
.service("FakturaciaService", FakturaciaService)
.name;



// WEBPACK FOOTER //
// ./src/Fakturacia/index.js